<template>
  <SearchInput v-bind:limitNum = "limitNum"/>
</template>

<script>
  import SearchInput from './SearchInput'

  export default {
      components: {
        SearchInput
       },
      data() {
          return {
            limitNum: 10
        }
      },
      methods: {
      }
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">

</style>


